<template>
    <div class="tccc_student">
        <p class="title">新增意向学员</p>
        <el-form ref="formRef" :model="form" label-width="110px" :inline="true">
            <el-form-item
                label="学员姓名"
                prop="name"
                :rules="[
                    {
                        required: true,
                        message: '学员姓名不能为空',
                        trigger: 'blur',
                    },
                ]"
            >
                <el-input
                    v-model="form.name"
                    placeholder="请输入学员名称"
                    style="width: 300px"
                />
            </el-form-item>
            <el-form-item
                label="手机号"
                prop="phone"
                :rules="[
                    {
                        required: true,
                        pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
                        message: '请输入正确的手机号码',
                        trigger: 'blur',
                    },
                ]"
            >
                <el-input
                    v-model="form.phone"
                    disabled
                    placeholder="请输入手机号"
                    style="width: 300px"
                />
            </el-form-item>
            <el-form-item
                label="一级渠道"
                prop="firstChannelName"
                :rules="[
                    {
                        required: true,
                        message: '请选择一级渠道',
                        trigger: 'blur',
                    },
                ]"
            >
                <div style="display: flex; align-items: center">
                    <el-input
                        v-model="form.firstChannelName"
                        style="width: 300px"
                        disabled
                    />
                </div>
            </el-form-item>
            <el-form-item
                label="二级渠道"
                prop="secondChannelName"
                :rules="[
                    {
                        required: true,
                        message: '请选择二级渠道',
                        trigger: 'blur',
                    },
                ]"
            >
                <div style="display: flex; align-items: center">
                    <el-input
                        v-model="form.secondChannelName"
                        style="width: 300px"
                        disabled
                    />
                </div>
            </el-form-item>
            <el-form-item
                label="分配校区"
                prop="schoolId"
                :rules="[
                    {
                        required: true,
                        message: '请选择分配校区',
                        trigger: 'change',
                    },
                ]"
            >
                <school-cascader
                    style="width: 300px"
                    v-model="form.schoolId"
                    ref="schoolCasAdd"
                    v-model:presentText="form.schoolName"
                    placeholder="区域/校区"
                    type="notShutdown"
                    :props="{ multiple: false }"
                    :checkAll="false"
                />
            </el-form-item>
            <el-form-item
                label="市场人员"
                prop="marketerName"
                :rules="[
                    {
                        required: isDfp,
                        message: '请选择市场人员',
                        trigger: 'change',
                    },
                ]"
            >
                <div style="display: flex; align-items: center">
                    <el-input
                        v-model="form.marketerName"
                        style="width: 300px"
                        readonly
                    />
                    <el-button
                        link
                        type="primary"
                        @click="openSearchUser = true"
                        >查找</el-button
                    >
                </div>
            </el-form-item>

            <el-form-item
                label="分配职业规划顾问"
                prop="ownerName"
                :rules="[
                    {
                        required: !isDfp,
                        message: '请选择分配职业规划顾问',
                        trigger: 'change',
                    },
                ]"
            >
                <div style="display: flex; align-items: center">
                    <el-input
                        v-model="form.ownerName"
                        style="width: 300px"
                        readonly
                    />
                    <el-button
                        link
                        type="primary"
                        @click="openSearchUserOwner = true"
                        >查找</el-button
                    >
                </div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm()">新建意向学员</el-button>
            </el-form-item>
        </el-form>
        <user-popup-modal
            v-model:visible="openSearchUser"
            title="选择市场人员"
            @getInfo="getUserInfo"
            :params="{ roleKeys: 'kf,kfjl' }"
            :type="2"
        />
        <user-popup-modal
            v-model:visible="openSearchUserOwner"
            title="选择分配职业规划顾问"
            @getInfo="getUserInfoOwner"
            :type="1"
        />
    </div>
</template>

<script setup>
import useUserStore from '@/store/modules/user';
import {
    setStudentBySessionid
} from "@/api/Tccc/index";
import { useTcccStore } from '@/store/modules/tccc'
import { insertLead } from "@/api/studentmange";
import { ElMessage } from "element-plus";
import userPopupModal from "@/views/studentmange/cmp/userPopupModal.vue";
import { onMounted } from 'vue';
const tcccStore = useTcccStore()
const { recordId } = defineProps({
    recordId:{
        type:String,
        default:""
    }
})
const userStore = useUserStore();

const { sessionId, callInPhone,showTccc } = storeToRefs(tcccStore)
const formRef = ref(); //form dom元素
const form = ref({
        firstChannelId:'a392019916B7C62gQV5q',
        firstChannelName: "线下市场",
        secondChannelId:"a392019E3A7D1E5L3QUg",
        secondChannelName: "主动来电",
        phone:callInPhone.value,
        schoolName:""
}); //表单数据
onMounted(()=>{
    if (userStore.userInfo.schoolId) {
        form.value.schoolId = userStore.userInfo.schoolId;
    }
    form.value.ownerName = userStore.userInfo.name;
    form.value.ownerId = userStore.userInfo.userId;
    form.value.marketerName = userStore.userInfo.name;
    form.value.marketerId = userStore.userInfo.userId;
})
const openSearchUser = ref(false);
const openSearchUserOwner = ref(false);
function getUserInfo(val) {
    Object.assign(form.value, {
        marketerId: val.id,
        marketerName: val.name,
    });
}
function getUserInfoOwner(val) {
    Object.assign(form.value, {
        ownerId: val.id,
        ownerName: val.name,
    });
}
const emits = defineEmits(['success'])
//确认新增意向学员
function submitForm() {
    formRef.value.validate((valid) => {
        if (valid) {
            insertLead(form.value)
                .then((res) => {
                    ElMessage({
                        type:"success",
                        message:"新建成功"
                    })
                    if(res.stuId){
                        setStudentBySessionid(recordId,res.stuId)
                        emits('success',{
                                id:res.stuId,
                                ...form.value,
                                studentName:form.value.name,
                                teacherName:form.value.ownerName,
                            }
                        )
                    }
                })
                .catch(() => {

                });
        }
    });
}
</script>

<style lang="scss" scoped>
.tccc_student{
    .title{
        font-size: 16px;
        font-weight: bold;
        line-height: 36px;
        margin-left: 40px;
        color:#333;
    }
}
</style>
